export default __webpack_public_path__ + "static/tasks-mobile-4f8006b3636957034ddf6706ddd39b8e.svg";